import React from 'react'
import { useHistory } from 'react-router'
import moment from 'moment'

// components
import ActionButton from '../../../../../components/buttons/ActionButton/ActionButton.component'

// mui
import { ButtonGroup } from '@mui/material'


export default function JobDayActions({ data, loading, error, id }) {

    const history = useHistory()

    if(loading) { return null }

    let actionsAvailable = false

    if(data && data.jobDay) {
        // check the date
        const today = moment()
        const jobDayDate = moment(data.jobDay.date)

        // allow actions if it is within allowed date range
        if(jobDayDate.diff(today, 'days') >= -7) {
            actionsAvailable = true
        }

        // disable actions if the approval process has already started on the assignments
        let approvalStarted = false
        data.jobDay.crewMemberAssignments.forEach(assignment => {
            if(assignment.preliminaryApproval){
                approvalStarted = true
            }
        })

        actionsAvailable = actionsAvailable && !approvalStarted
    }

    return (<ButtonGroup variant="outlined">
        {
            actionsAvailable 
            && (<React.Fragment>
                <ActionButton label="Split Job Day" color='secondary' onClick={() => history.push(`/schedule/split/${id}`)} />
                <ActionButton label="Process Time Tickets" color='secondary' onClick={() => history.push(`/schedule/time-tickets/${id}`)} />
            </React.Fragment>)
        }
        <ActionButton label="Send Receipt" color="secondary" onClick={() => history.push(`/schedule/send-receipt/${id}`)} />
    </ButtonGroup>)
}